import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Array com apenas as imagens - texto será fixo (otimizadas em JPG)
const bannerImages: string[] = [
  '/images/banner/IMG_1831.jpg',
  '/images/banner/IMG_3604.jpg',
  '/images/banner/IMG_3622.JPG',
  '/images/banner/IMG_5752.jpg',
];

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(0);

  const nextSlide = useCallback(() => {
    setDirection(1);
    setCurrentSlide((prev) => (prev + 1) % bannerImages.length);
  }, []);

  const prevSlide = useCallback(() => {
    setDirection(-1);
    setCurrentSlide((prev) => (prev - 1 + bannerImages.length) % bannerImages.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 6000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    }),
  };


  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Background Images - Animadas */}
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={currentSlide}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: 'spring', stiffness: 300, damping: 30 },
            opacity: { duration: 0.5 },
          }}
          className="absolute inset-0"
        >
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${bannerImages[currentSlide]})` }}
          >
            {/* Gradient Overlay - Verde escuro da marca */}
            <div className="absolute inset-0 bg-gradient-to-b from-floresta/70 via-floresta/50 to-floresta/70" />
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Content - Fixo na tela, sempre visível, z-index alto */}
      <div className="absolute inset-0 z-20 flex items-center justify-center text-center pointer-events-none">
        <div className="container-custom px-4">
          <h1 className="text-white mb-6 max-w-4xl mx-auto drop-shadow-2xl" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8)' }}>
            Transformar é a nossa Arte. <span className="text-argila italic">Verde é a nossa essência</span>
          </h1>

          <p className="text-white text-lg md:text-xl lg:text-2xl mb-10 max-w-3xl mx-auto drop-shadow-lg" style={{ textShadow: '1px 1px 6px rgba(0,0,0,0.8)' }}>
            Especialistas em soluções de paisagismo com plantas naturais, preservadas e artificiais
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pointer-events-auto">
            <a
              href="#contato"
              className="btn-primary text-lg px-8 py-4 hover:scale-105"
            >
              Solicitar Orçamento
            </a>
          </div>
        </div>
      </div>
      {/* Navigation Arrows - Hidden on Mobile */}
      <button
        onClick={prevSlide}
        className="hidden md:block absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 md:p-4 rounded-full transition-all duration-300 hover:scale-110"
        aria-label="Previous slide"
      >
        <FaChevronLeft size={24} />
      </button>

      <button
        onClick={nextSlide}
        className="hidden md:block absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 md:p-4 rounded-full transition-all duration-300 hover:scale-110"
        aria-label="Next slide"
      >
        <FaChevronRight size={24} />
      </button>

      {/* Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-3">
        {bannerImages.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              setDirection(index > currentSlide ? 1 : -1);
              setCurrentSlide(index);
            }}
            className={`transition-all duration-300 rounded-full ${
              index === currentSlide
                ? 'w-12 bg-primary-500'
                : 'w-3 bg-white/50 hover:bg-white/70'
            } h-3`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

    </div>
  );
};

export default HeroSlider;
